import { Component } from '@angular/core'
import { Meta, Title } from '@angular/platform-browser'
import { SEOService } from '@flowaccount/landing'
import { SignupPreviousPath } from '../../../enum/landing-enum'
import { TranslateService } from '@ngx-translate/core'
import { Subscription } from 'rxjs'

@Component({
  selector: 'flowaccount-billing-note-invoice',
  templateUrl: './billing-note-invoice.component.html',
  styleUrls: ['./billing-note-invoice.component.scss'],
})
export class BillingNoteInvoiceComponent {
  public customHeader = {
    heading: 'BLOG_SWIPER_TOPIC.HEADING_INVOICE',
    detail: 'BLOG_SWIPER_TOPIC.DETAIL_INVOICE',
  }
  public contentDocuments: object[]
  public signupPreviousPath = SignupPreviousPath
  protected langChangeSubscription: Subscription

  constructor(
    public translate: TranslateService,
    private seoService: SEOService,
    private titleService: Title,
    private metaService: Meta,
  ) {
    this.setMeta()
    this.langChangeSubscription = translate.onLangChange.subscribe((event) => {
      this.setMeta()
    })
  }
  ngOnInit() {
    this.showContentDocuments()
  }
  setMeta() {
    this.titleService.setTitle(this.translate.instant('metatitle-Function-billing-note-invoice'))
    this.seoService.createMetaTag(
      this.translate.instant('metatitle-Function-billing-note-invoice'),
      this.translate.instant('metaDescription-billing-note-invoice'),
    )
    this.seoService.createOg(
      'https://flowaccountcdn.com/new_landing/image/og/billingNote_og_image.jpg',
      this.translate.instant('metatitle-Function-billing-note-invoice'),
      this.translate.instant('metaDescription-billing-note-invoice'),
    )
  }

  ngOnDestroy() {
    this.langChangeSubscription.unsubscribe()
  }
  showContentDocuments() {
    const lang = this.translate.currentLang
    this.contentDocuments = [
      {
        image: `https://flowaccountcdn.com/new_landing/image/functions/mobile-documents/invoice/${lang}/1.png`,
        imageWebp: `https://flowaccountcdn.com/new_landing/image/functions/mobile-documents/invoice/${lang}/1.webp`,
        detail: 'BILLING_NOTE_INVOICE.MOBILE_DOCUMENTS.CONTENT.1',
      },
      {
        image: `https://flowaccountcdn.com/new_landing/image/functions/mobile-documents/invoice/${lang}/2.png`,
        imageWebp: `https://flowaccountcdn.com/new_landing/image/functions/mobile-documents/invoice/${lang}/2.webp`,
        detail: 'BILLING_NOTE_INVOICE.MOBILE_DOCUMENTS.CONTENT.2',
      },
      {
        image: `https://flowaccountcdn.com/new_landing/image/functions/mobile-documents/invoice/${lang}/3.png`,
        imageWebp: `https://flowaccountcdn.com/new_landing/image/functions/mobile-documents/invoice/${lang}/3.webp`,
        detail: 'BILLING_NOTE_INVOICE.MOBILE_DOCUMENTS.CONTENT.3',
      },
    ]
  }
}
